// DS: C16A, C16B
/** A collapsable, lazy loaded editor specifically configured for comment posting */
import React from 'react';
import AnonymousView from './views/AnonymousView';
import CantPostView from './views/CantPostView';
import EditorView from './views/EditorView';
import CommentBoxSkeleton, {
  CommentBoxSkeletonProps,
} from '../CommentBoxSkeleton';

export interface Props
  extends Omit<
    Optional<CommentBoxSkeletonProps, 'editorView'>,
    'loggedOutView' | 'cantPostView'
  > {
  ['aria-label']?: string;
  ['aria-labelledby']?: string;

  /** @deprecated Don't use this unless you know what you're doing, this is going away */
  nc?: {
    messageId: string;
    folderId: number | null;
    shouldDeleteMessage: boolean;
    postfix: React.ReactNode;
  };

  onPost?: () => void;
  onClose?: () => void;

  /** @deprecated Ideally make a new component instead */
  footerClassName?: string;
}

/** Our classic CommentBox implementation. */
const CommentBox = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      onPost,
      onClose,
      footerClassName,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      nc,
      editorView,
      ...rest
    },
    ref
  ) => {
    return (
      <CommentBoxSkeleton
        loggedOutView={<AnonymousView />}
        editorView={
          editorView || (
            <EditorView
              nc={nc}
              onPost={onPost}
              onCancel={onClose}
              footerClassName={footerClassName}
              aria-label={ariaLabel}
              aria-labelledby={ariaLabelledBy}
            />
          )
        }
        cantPostView={<CantPostView />}
        ref={ref}
        {...rest}
      />
    );
  }
);
CommentBox.displayName = 'CommentBox';

export default CommentBox;
